import React from "react";
import styled from "styled-components";
import { FacebookIcon, TwitterIcon, LinkedInIcon } from "./Icons";
import brandLogo from "../images/brand-logo-white.svg";
import { resource } from "../localization/resource";

export const Footer: React.VFC = () => (
  <StyledFooter>
    <div className="container">
      <div className="row">
        <div className="col-12 socials">
          <a className="social-link" href="https://www.facebook.com/EquisoftSolutions">
            <FacebookIcon />
          </a>
          <a className="social-link" href="https://twitter.com/equisoft">
            <TwitterIcon />
          </a>
          <a className="social-link" href="https://www.linkedin.com/company/equisoft">
            <LinkedInIcon />
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="copyright-links">
            <a href="#">{resource("common.privacyPolicy")}</a>
            <a href="#">{resource("common.termsOfUse")}</a>
          </div>
        </div>
      </div>
    </div>
  </StyledFooter>
);

const StyledFooter = styled.footer`
  flex: 0 0 auto;
  background: var(--footer-color);
  padding: 50px 0 50px;
  color: #ccc;

  a {
    color: #ccc;

    &:hover {
      color: #fff;
    }
  }

  .address {
    margin-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .socials {
    text-align: center;
    padding-top: 30px;

    .social-link {
      border-radius: 100%;
      display: inline-block;
      background: #444;
      padding: 8px;
      width: 45px;
      height: 45px;
      margin-left: 15px;
      transition: all 0.2s linear;
      color: #fff;

      svg {
        display: block;
        width: 100%;
        fill: currentColor;
      }

      &:hover {
        background: #fff;
        color: #333;
      }
    }
  }

  .copyright-links {
    text-align: center;
    font-size: 12px;
    font-weight: 600;

    a + a {
      margin-left: 30px;
    }
  }
`;
